module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAABXUlEQVQ4T6WSv0ocURTGz3dnJHmBYJEHEAykskhsVEJqi1U412oLG6ukSxoRtBJEJT6BNjNwHV/BgL1a2a+NLEqKkE2x3D2fjDCwf2Ys9LaH3/c73PNBXvEwzKrqoojsAHhoyOxkWfa9mo3A3vuDfr9/UhTFVR2squd5ni+NwKURwDLJBQA3InLfYF4RkVMze+h2u7tPZlW9JLluZvbcF6Rp+o7kJwDvSZ5U8Mg6TQHe+2mS8yLyEcDvCbjdbr/t9Xpv6gJCCH9FhKq6NQGr6hcAP0Xk3zhMshTd5Xm+MQ5fk9x2zq3GGHdDCNd1Zu/9hZntAfBmdvS0tvf+g4jMkVwbDAY7zrnylslwAMlfzrlDAPtm9t/MzibuHGM8bjLX3rkylCWJMRZJknwjmQ6bnXNHJDcnSjIGv8ysqj8AzJDs1HxYAuBzlmVfa7stImi1WrPOuamGotyGEP5Us0excrYzcAgBAQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./assets/images/icon_b1.png
// module id = Y2Il
// module chunks = 14 17